import { render, staticRenderFns } from "./new_worklist_dialog_new.vue?vue&type=template&id=31bff281&scoped=true"
import script from "./new_worklist_dialog_new.vue?vue&type=script&lang=js"
export * from "./new_worklist_dialog_new.vue?vue&type=script&lang=js"
import style0 from "./new_worklist_dialog_new.vue?vue&type=style&index=0&id=31bff281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bff281",
  null
  
)

export default component.exports